import { INSTRUMENT_FAMILIES } from "constants/routes";
import { serviceRoles } from "config/access";
import { checkAccess } from "helpers/auth";
import InstrumentFamiliePage from "./container/InstrumentFamiliePage";

export default function getSettingsRoute(userAuth) {
  const { account } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: INSTRUMENT_FAMILIES,
    withSidebar: true,
    withAppBar: true,
    component: InstrumentFamiliePage,
  };
}
